import Accommodation from '../components/campusLife/accommodation'
import BtnLink from '../components/campusLife/BtnLink'
import DetailRooms from '../components/campusLife/detailRooms'
import { useSelector } from 'react-redux'
import { retrunAssets } from '../utils/getAssets'
import UnitEnquiries from '../components/campusLife/unitEnquiries'
import { useState } from 'react'
import { useEffect } from 'react'
import { useMemo } from 'react'

const PutrajayaAccommodationMenu = () => {
  const state = useSelector(state => state.campusLifeTab)
  const campusLife = state?.data?.properties
  const accommodationSlideImages =
    campusLife?.accommodationSlideImages !== null
      ? campusLife?.accommodationSlideImages?.map(item =>
          retrunAssets(item.url)
        )
      : []
  const accommodationItemLinks = useMemo(
    () =>
      campusLife?.accommodations !== null
        ? campusLife?.accommodations?.map(item => ({
            name: item?.name,
            path: item?.route?.path
          }))
        : [],
    [campusLife]
  )

  const [data, setData] = useState({
    list: [],
    contents: []
  })

  useEffect(() => {
    if (campusLife?.unitEnquiries == null) {
      setData({
        list: accommodationItemLinks
          ? [
              ...accommodationItemLinks.map((item, index) => ({
                title: item.name,
                index: index
              }))
            ]
          : [],
        contents: accommodationItemLinks
          ? [
              ...accommodationItemLinks.map((item, index) => (
                <DetailRooms key={index} data={item} />
              ))
            ]
          : []
      })
    } else {
      setData({
        list: accommodationItemLinks
          ? [
              ...accommodationItemLinks.map((item, index) => ({
                title: item.name,
                index: index
              })),
              { title: 'Unit Enquiries', index: accommodationItemLinks?.length }
            ]
          : [],
        contents: accommodationItemLinks
          ? [
              ...accommodationItemLinks.map((item, index) => (
                <DetailRooms key={index} data={item} />
              )),
              <UnitEnquiries
                url={campusLife?.unitEnquiries?.route?.path}
                key='1'
              />
            ]
          : []
      })
    }
  }, [campusLife, accommodationItemLinks])

  const campusAccommodationDownload = campusLife?.campusAccommodationDownload
    ? retrunAssets(campusLife?.campusAccommodationDownload)
    : null
  const accommodationAppealFormDownload =
    campusLife?.accommodationAppealFormDownload
      ? retrunAssets(campusLife?.accommodationAppealFormDownload)
      : null
  const accommodationRateDownload = campusLife?.accommodationRateDownload
    ? retrunAssets(campusLife?.accommodationRateDownload)
    : null
  const accommodationInformationKits = campusLife?.accommodationInformationKits
    ? retrunAssets(campusLife?.accommodationInformationKits)
    : null
  return (
    <Accommodation
      imgSlider={accommodationSlideImages}
      contents={data?.contents}
      list={data?.list}
    >
      <>
        <div
          className='w-full h-[20rem] relative rounded shadow bg-center bg-cover bg-no-repeat bg-gray-200'
          style={{
            backgroundImage: `url('https://www.uniten.edu.my/media/1935/student-life-08-accommodation.jpg')`
          }}
        ></div>
        {/* <span className=" text-center  w-auto text-sky-950 text-opacity-70 text-base font-normal  leading-normal">Click here to Download Putrajaya Campus brochure</span> */}
        {campusAccommodationDownload && (
          <div className='w-full py-4 '>
            <BtnLink
              text='Download Campus Accommodation'
              file={campusAccommodationDownload}
            />
          </div>
        )}
        <div className='w-auto flex flex-col  text-justify'>
          <span className='text-sky-950 text-opacity-70 text-base font-normal  leading-normal'>
            Students may appeal for on-campus residence placement if there is
            special requirement or need to be within campus.{' '}
          </span>
          <span className='text-black text-opacity-70 text-base font-bold  leading-normal'>
            Download the appeal form below:
          </span>
        </div>
        <div className='w-full flex flex-col gap-5 py-4 '>
          {accommodationAppealFormDownload && (
            <BtnLink
              text='Accommodation Appeal Form'
              file={accommodationAppealFormDownload}
            />
          )}
          {accommodationRateDownload && (
            <BtnLink
              text='Accommodation Rate'
              file={accommodationRateDownload}
            />
          )}
          {accommodationInformationKits && (
            <BtnLink
              text='Accommodation Information kits'
              file={accommodationInformationKits}
            />
          )}
        </div>
      </>
    </Accommodation>
  )
}

export default PutrajayaAccommodationMenu
